import AdsConfigDialog from '@/components/dialog/ads-config-dialog.vue'
import AdsPreviewDialog from '@/components/dialog/ads-preview-dialog.vue'
import DistinctProductsDialog from '@/components/dialog/distinct-products-dialog.vue'
export default {
	AdsConfigDialog,
	AdsPreviewDialog,
	DistinctProductsDialog
}
	
	